import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { StoreService } from '../../store.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DomSanitizer } from '@angular/platform-browser';
import { EmailEditorComponent } from 'angular-email-editor';
import { UtilitiesService } from '../../core/utilities.service';
import _ from 'underscore';

declare const $: any;

@Component({
  selector: 'app-editTemplate',
  templateUrl: './edit-template.component.html',
  styleUrls: ['./edit-template.component.scss'],
})
export class EditTemplateComponent implements OnInit {
  @Input() mediaID: string | number = undefined;

  titleName = 'angular-email-editor';
  @ViewChild(EmailEditorComponent)
  private emailEditor: EmailEditorComponent;

  emailOption = {};
  message: string;
  bearer;
  templates: any = [];
  tempForm: FormGroup;
  closeResult = '';
  status;
  errorMsg = '';
  errorStatus = false;
  updateStatus = false;

  store_id;
  template_id;
  lang;

  template_image;
  loading = true;

  custom_name = '';
  json_template;
  params;
  imageURL = '';
  customEmailId: 0;
  defaultTemplate: any = [];
  isSame = false;

  constructor(
    private route: ActivatedRoute,
    private svc: StoreService,
    private modalService: NgbModal,
    private router: Router,
    private sanitizer: DomSanitizer,
    private utils: UtilitiesService,
    private formBuilder: FormBuilder
  ) {}

  ngOnInit(): void {
    this.bearer = localStorage.getItem('bearer');
    this.store_id = localStorage.getItem('store_id');
    // this.svc.getEmailTemplates(this.bearer, this.store_id).subscribe((res) => {
    this.svc.getEmailTemplates(this.bearer).subscribe((res) => {
      this.defaultTemplate = res['data'][0];
      this.defaultTemplate = JSON.parse(this.defaultTemplate.template_json);
    });
    this.getInfo();
    this.widgetOption();
  }

  getInfo() {
    this.getTemplate();
    this.tempForm = this.formBuilder.group({
      template_name: [''],
    });
  }

  widgetOption() {
    this.emailOption = {
      version: '1.33.0',
      tools: {
        menu: {
          enabled: false,
        },
        // image: {
        //   enabled: false
        // }
      },

      fonts: {
        showDefaultFonts: false,
      },

      // appearance: {
      //   panels: {
      //     tools: {
      //       dock: 'left'
      //     }
      //   },
      //   loader: {
      //     // html: '<div class="custom-spinner"></div>',
      //     // css: '.custom-spinner { color: red; }'
      //   }
      // },

      mergeTags: {
        customer_name: {
          name: 'Customer Name',
          value: '{{ customer_name }}',
          sample: 'Thomas',
        },
        customer_phone: {
          name: 'Customer Phone',
          value: '{{ customer_phone }}',
          sample: '0112345678',
        },
        customer_address: {
          name: 'Customer Address',
          value: '{{ customer_address }}',
          sample: 'Taman Bandar, Jalan City, Sungai Besi, 57000 Kuala Lumpur',
        },
        store_name: {
          name: 'Store Name',
          value: '{{ store_name }}',
          sample: 'Wellous Store',
        },
        company_email: {
          name: 'Store Email',
          value: '{{ company_email }}',
          sample: 'estoremail@mail.com',
        },
        company_phone: {
          name: 'Store Phone',
          value: '{{ company_phone }}',
          sample: '03301234567',
        },
        invoice_no: {
          name: 'Invoice Number',
          value: '{{ invoice_no }}',
          sample: '220012345',
        },
        order_id: {
          name: 'Order Number',
          value: '{{ order_id }}',
          sample: '671899',
        },
        order_date: {
          name: 'Order Date',
          value: '{{ order_date }}',
          sample: 'March 23,2022',
        },
        shipping_method: {
          name: 'Shipping Method',
          value: '{{ shipping_method }}',
          sample: 'Poslaju',
        },
        product_details: {
          name: 'Product Details',
          value: '{{ product_details }}',
          sample: '',
        },
        currency_symbol: {
          name: 'Currency Symbol',
          value: '{{ currency_symbol }}',
          sample: 'RM',
        },
        voucher: {
          name: 'Voucher',
          value: '{{ voucher }}',
          sample: '00.00',
        },
        subtotal: {
          name: 'Subtotal',
          value: '{{ subtotal }}',
          sample: '00.00',
        },
        discount: {
          name: 'Discount',
          value: '{{ discount }}',
          sample: '00.00',
        },
        total_price: {
          name: 'Total Price',
          value: '{{ total_price }}',
          sample: '00.00',
        },
      },
    };
  }

  getStatus() {
    if (
      this.defaultTemplate.length < 1 ||
      this.json_template === undefined ||
      this.isSame
    )
      return false;
    return !_.isEqual(this.defaultTemplate, this.json_template);
  }

  editorLoaded(templates) {
    // load the design json here
    this.emailEditor.loadDesign(this.json_template);
  }

  exportHtml() {
    this.updateStatus = false;

    const template_name = this.tempForm.get('template_name').value;

    if (template_name === '' || template_name === null) {
      this.utils.notify.showError(
        this.utils.translate('Please enter template name')
      );
      this.errorMsg = 'Template name is required';
      this.errorStatus = true;

      setTimeout(() => {
        if (this.errorStatus) {
          this.errorStatus = false;
        }
      }, 3000);
      return;
    } else {
      this.templates.template_name = template_name;
    }

    this.loading = true;

    this.emailEditor.editor.exportHtml((data) => {
      this.templates.custom_by = this.store_id;
      this.templates.store_id = parseInt(this.store_id);
      this.templates.template_id = parseInt(this.templates.template_id);
      this.templates.template_html = data.html;
      this.templates.template_json = JSON.stringify(data.design);
      this.updateStatus = true;
      this.templates.template = data.html;
      this.svc.updateEmailTemplate(this.templates, this.bearer).subscribe(
        (res) => {
          this.isSame = false;
          this.getTemplate();
        },
        (err) => {
          this.updateStatus = false;
        }
      );
    });

    setTimeout(() => {
      this.loading = false;

      if (this.updateStatus) {
        this.utils.notify.showSuccess(
          this.utils.translate('Updated Successfully!')
        );
      } else {
        this.utils.notify.showError(this.utils.translate('Update Failed!'));
      }
    }, 3000);
  }

  saveDesign() {
    this.emailEditor.saveDesign((design) => console.log('saveDesign', design));
  }

  getTemplate() {
    let id =
      this.customEmailId !== 0 && this.customEmailId !== undefined
        ? this.customEmailId
        : this.route.snapshot.paramMap.get('id');
    this.svc.getEmailTemplatebyId(this.bearer, id).subscribe((res) => {
      this.templates = res['data'];
      this.json_template =
        res['data']['template_json'] === '' ||
        res['data']['template_json'] === undefined
          ? ''
          : JSON.parse(res['data']['template_json']);
      this.custom_name = res['data']['template_name'];

      this.tempForm.setValue({
        template_name: res['data']['template_name'],
      });

      this.loading = false;
      this.emailEditor.loadDesign(this.json_template);

      this.emailEditor.editor.registerCallback('selectImage', (file, done) => {
        // Call Upload Image API
        $('#media-selector-embed .media-selector-container .btn').click();
        this.selectedImage = { done };
      });
    });
  }

  selectedImage: any;

  handleMediaChanged($e) {
    this.selectedImage.done({ url: $e.url });
  }

  handleSetImageInputID({ e }) {
    console.log('handleSetImageInputID', { e });
  }

  revertTemplate() {
    this.utils.msgBox.open({
      message: this.utils.translate(
        'Are you sure you want to perform this action? This could erase all the changes you have made.'
      ),
      title: this.utils.translate('Confirm Revert?'),
      icon: 'warning',
      buttonList: [
        {
          text: this.utils.translate('Cancel'),
        },
        {
          text: this.utils.translate('Revert'),
          style: 'danger',
          onClick: () => {
            this.loading = true;
            const body = {
              store_id: this.store_id,
              custom_email_id:
                this.customEmailId !== 0 && this.customEmailId !== undefined
                  ? this.customEmailId
                  : this.route.snapshot.paramMap.get('id'),
            };
            this.svc.revertEmailTemplate(body, this.bearer).subscribe(
              (response) => {
                this.updateStatus = true;
                this.isSame = true;
                this.customEmailId = response['data'].custom_email_id;
                this.router.navigate([
                  '/dashboard/edit-template',
                  this.customEmailId,
                ]);
              },
              (err) => {
                this.updateStatus = false;
              }
            );

            setTimeout(() => {
              this.loading = false;

              if (this.updateStatus) {
                this.utils.notify.showSuccess(
                  this.utils.translate('Reverted Successfully!')
                );
                this.getInfo();
              } else {
                this.utils.notify.showError(
                  this.utils.translate('Update Failed!')
                );
              }
            }, 3000);
          },
        },
      ],
    });
  }
}
